"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeApiKeySuccess = exports.removeApiKey = exports.getUserApiKeys = exports.getApiKeysSuccess = exports.getApiKeysRequested = exports.editApiKeyWhitelistSuccess = exports.editApiKeyWhitelistIpAddress = exports.createApiKey = exports.addApiKey = exports.REMOVE_API_KEY_SUCCESS = exports.GET_API_KEYS_SUCCESS = exports.GET_API_KEYS_REQUESTED = exports.GET_API_KEYS_ERROR = exports.EDIT_API_KEY_IP_ADDRESS_SUCCESS = exports.ADD_API_KEY = void 0;
var _apiActions = require("./apiActions");
var _modalActions = require("./modalActions");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var GET_API_KEYS_REQUESTED = exports.GET_API_KEYS_REQUESTED = 'GET_API_KEYS_REQUESTED';
var GET_API_KEYS_SUCCESS = exports.GET_API_KEYS_SUCCESS = 'GET_API_KEYS_SUCCESS';
var GET_API_KEYS_ERROR = exports.GET_API_KEYS_ERROR = 'GET_API_KEYS_ERROR';
var ADD_API_KEY = exports.ADD_API_KEY = 'ADD_API_KEY';
var REMOVE_API_KEY_SUCCESS = exports.REMOVE_API_KEY_SUCCESS = 'REMOVE_API_KEY_SUCCESS';
var EDIT_API_KEY_IP_ADDRESS_SUCCESS = exports.EDIT_API_KEY_IP_ADDRESS_SUCCESS = 'EDIT_API_KEY_IP_ADDRESS_SUCCESS';
var createApiKey = exports.createApiKey = function createApiKey(formValues) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(dispatch, getState) {
      var UserId, Permissions, apiKey;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            UserId = getState().user.userInfo.UserId;
            Permissions = [];
            if (formValues.trading) Permissions.push('Trading');
            if (formValues.withdraw) Permissions.push('Withdraw');
            if (formValues.deposit) Permissions.push('Deposit');
            if (formValues.accountReadOnly) Permissions.push('AccountReadOnly');
            _context.n = 1;
            return dispatch((0, _apiActions.callAPI)('AddUserAPIKey', _objectSpread({
              UserId: UserId,
              Permissions: Permissions
            }, formValues.IpWhiteList && {
              IpWhiteList: formValues.IpWhiteList
            })));
          case 1:
            apiKey = _context.v;
            dispatch((0, _modalActions.openModal)(_modalActions.MODAL_TYPES.NEW_API_KEY, {
              apiKey: apiKey
            }));
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
var getUserApiKeys = exports.getUserApiKeys = function getUserApiKeys(UserId) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(dispatch) {
      var keys;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            dispatch(getApiKeysRequested());
            _context2.n = 1;
            return dispatch((0, _apiActions.callAPI)('GetUserAPIKeys', {
              UserId: UserId
            }));
          case 1:
            keys = _context2.v;
            if (Array.isArray(keys)) {
              dispatch(getApiKeysSuccess(keys));
            }
          case 2:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function (_x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var getApiKeysRequested = exports.getApiKeysRequested = function getApiKeysRequested() {
  return {
    type: GET_API_KEYS_REQUESTED
  };
};
var getApiKeysSuccess = exports.getApiKeysSuccess = function getApiKeysSuccess(payload) {
  return {
    type: GET_API_KEYS_SUCCESS,
    payload: payload
  };
};
var addApiKey = exports.addApiKey = function addApiKey(payload) {
  return {
    type: ADD_API_KEY,
    payload: payload
  };
};
var removeApiKeySuccess = exports.removeApiKeySuccess = function removeApiKeySuccess(payload) {
  return {
    type: REMOVE_API_KEY_SUCCESS,
    payload: payload
  };
};
var editApiKeyWhitelistSuccess = exports.editApiKeyWhitelistSuccess = function editApiKeyWhitelistSuccess(payload) {
  return {
    type: EDIT_API_KEY_IP_ADDRESS_SUCCESS,
    payload: payload
  };
};
var editApiKeyWhitelistIpAddress = exports.editApiKeyWhitelistIpAddress = function editApiKeyWhitelistIpAddress(payload) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(dispatch, getState) {
      var UserId, response;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            UserId = getState().user.userInfo.UserId;
            _context3.n = 1;
            return dispatch((0, _apiActions.callAPI)('UpdateUserAPIKeyWhitelist', {
              UserId: UserId,
              APIKey: payload.APIKey,
              IpWhiteList: payload.IpWhiteList,
              Permissions: payload.Permissions
            }));
          case 1:
            response = _context3.v;
            if (response) {
              dispatch(editApiKeyWhitelistSuccess(response));
            }
            dispatch((0, _modalActions.closeModal)(_modalActions.MODAL_TYPES.EDIT_API_KEY_WHITELIST_IP_ADDRESS));
          case 2:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return function (_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var removeApiKey = exports.removeApiKey = function removeApiKey(APIKey) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(dispatch, getState) {
      var UserId, response;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            UserId = getState().user.userInfo.UserId;
            _context4.n = 1;
            return dispatch((0, _apiActions.callAPI)('RemoveUserAPIKey', {
              UserId: UserId,
              APIKey: APIKey
            }));
          case 1:
            response = _context4.v;
            if (response.result) {
              dispatch(removeApiKeySuccess(APIKey));
            }
          case 2:
            return _context4.a(2);
        }
      }, _callee4);
    }));
    return function (_x6, _x7) {
      return _ref4.apply(this, arguments);
    };
  }();
};